import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SpaceLogin from "assets/img/space-login.png";
import { StarDecorations } from "components/ui/StarDecorations";
import { PRODUTO_CONFIG } from "config/produto";
import { getProduto } from "config/produto-env";
import { useAuth } from "context/AuthContext";
import { invalidateCache } from "services/cache";
import { PESSOA_ME_CACHE_KEY } from "services/pessoa.service";

/**
 * Aviso de quem autentica mas não tem perfil na base (`player_fields__c`):
 * fora da base, ou erro ao carregar (com "tentar novamente").
 */
export function PerfilIndisponivel() {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [tentando, setTentando] = useState(false);
  const isErro = user?.perfil === "erro";
  const home = getProduto() === "PREMIO_ELBB" ? "/home-elbb" : "/home-public";

  const tentarNovamente = async () => {
    setTentando(true);
    invalidateCache(PESSOA_ME_CACHE_KEY);
    invalidateCache("fetch-user");
    try {
      await refreshUser();
      navigate("/");
    } finally {
      setTentando(false);
    }
  };

  return (
    <div className="min-h-screen">
      <div className="relative flex flex-col w-full min-h-screen bg-gradient-to-br from-blue-bb via-blue-bb-1 to-blue-bb-5 overflow-x-hidden">
        <main
          className="flex flex-col lg:flex-row flex-1 items-center justify-center px-4 sm:px-6 md:px-10 lg:px-16 relative gap-8 lg:gap-12"
          role="main"
        >
          <article className="w-full max-w-xl lg:max-w-2xl z-10 text-center lg:text-left space-y-4 sm:space-y-6">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-yellow-bb leading-tight">
              {isErro
                ? "Não conseguimos carregar seus dados"
                : `Seus dados ainda não constam na base do ${PRODUTO_CONFIG.titulo} 2027`}
            </h1>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white font-medium leading-relaxed">
              {isErro
                ? "Pode ser uma instabilidade momentânea. Tente novamente em instantes."
                : "Enquanto isso, você pode conhecer o Prêmio e as iniciativas na página inicial."}
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              {isErro && (
                <button
                  type="button"
                  onClick={tentarNovamente}
                  disabled={tentando}
                  className="px-6 py-3 rounded-full bg-yellow-bb text-blue-bb font-bold disabled:opacity-60"
                >
                  {tentando ? "Carregando..." : "Tentar novamente"}
                </button>
              )}
              <button
                type="button"
                onClick={() => navigate(home)}
                className="px-6 py-3 rounded-full border-2 border-white text-white font-bold"
              >
                Ir para a página inicial
              </button>
            </div>
          </article>

          <aside className="hidden lg:flex relative flex-shrink-0 opacity-50" aria-hidden="true">
            <img
              src={SpaceLogin}
              alt=""
              className="w-full max-w-md xl:max-w-2xl h-auto object-contain z-20"
              loading="lazy"
              decoding="async"
            />
          </aside>
        </main>

        <div aria-hidden="true" className="hidden md:block pointer-events-none">
          <StarDecorations count={25} density="medium" />
        </div>
      </div>
    </div>
  );
}
